import * as oauth from 'oauth4webapi';

export function buildStateAndCodeVerifier() {
  const state = oauth.generateRandomState();
  const codeVerifier = oauth.generateRandomCodeVerifier();

  return { state, codeVerifier };
}
